import React from 'react';
import { Box, Typography, Button } from '@mui/material';

const ServicePage: React.FC = () => {
  const handleAddReport = () => {
    // TODO: Implementacja dodawania zgłoszenia
    console.log('Dodaj zgłoszenie');
  };

  return (
    <Box sx={{ bgcolor: '#FAFAFA', mt: '20px' }}>
      {/* Nagłówek i przycisk Dodaj – zgodnie z układem stron projektów i ofert */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mt: 0, mb: 2 }}>
        <Typography
          component="h1"
          sx={{
            fontFamily: 'Roboto, sans-serif',
            fontSize: '20px',
            lineHeight: '24px',
            fontWeight: 400,
            color: '#020242',
            m: 0,
            mt: '8.5px'
          }}
        >
          Serwis usterkowy
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
          <Button 
            variant="contained" 
            onClick={handleAddReport}
            data-action="add-report"
            data-hotkey-add="true"
            sx={{ 
              width: 116,
              minWidth: 116,
              height: 40,
              borderRadius: '4px',
              textTransform: 'none',
              fontSize: '14px',
              fontWeight: 600,
              whiteSpace: 'nowrap',
              wordBreak: 'keep-all',
              backgroundColor: '#4040DB',
              color: '#fff',
              '&:hover': { backgroundColor: '#1F1FB0' },
              '&:active': { backgroundColor: '#1A1A98' }
            }}
          >
            Dodaj zgłoszenie
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default ServicePage;







